import { render, staticRenderFns } from "./NCardHeader.vue?vue&type=template&id=ef1289d4&scoped=true&"
import script from "./NCardHeader.vue?vue&type=script&lang=js&"
export * from "./NCardHeader.vue?vue&type=script&lang=js&"
import style0 from "./NCardHeader.vue?vue&type=style&index=0&id=ef1289d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1289d4",
  null
  
)

export default component.exports